import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { BomDataHelper } from '../../services/helpers/bom-data-helper';
import { CustomerService } from 'src/app/services/customer.service';
import { HbmIframeService } from 'src/app/services/hbm/hbm-iframe.service';

@Component({
  selector: 'ng-casto-price-infos',
  templateUrl: './price-infos.component.html',
})
export class PriceInfosComponent implements OnInit {
  public handledBom: any;

  constructor(
    public modalService: ModalService,
    public customer: CustomerService,
    public byMe: HbmIframeService
  ) {
    this.handledBom = BomDataHelper.extractBlockGroupedProductsList(modalService.currentDatas.bom);
  }

  ngOnInit(): void {}

  close() {
    this.modalService.close();
  }
}
